import { render } from "./TrailerInfo.vue?vue&type=template&id=5c848778&scoped=true"
import script from "./TrailerInfo.vue?vue&type=script&lang=js"
export * from "./TrailerInfo.vue?vue&type=script&lang=js"

import "./TrailerInfo.vue?vue&type=style&index=0&id=5c848778&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c848778"]])

export default __exports__